import React from 'react';
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles';

const lato = 'Lato, sans-serif';
const nunito = 'Nunito, sans-serif';

let theme = createTheme({
  typography: {
    fontFamily: nunito,
    h1: {
      fontFamily: lato,
    },
    h2: {
      fontFamily: lato,
    },
    h3: {
      fontFamily: lato,
    },
    h4: {
      fontFamily: lato,
    },
    h5: {
      fontFamily: lato,
    },
    h6: {
      fontFamily: lato,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          overflowX: 'hidden',
        },
      },
    },
  },
});
theme = responsiveFontSizes(theme);

function ThemeProvider({children}: {children: React.ReactNode}) {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}

export default ThemeProvider;
